import { TripType } from "./tripType"

export type Activity = {
  id: TripType;
  name: string;
  short_name?: string | undefined;
  points_per_unit: number;
  takes_number?: boolean | undefined;
}

export const ACTIVITIES : Activity[] = [
  {
    id: TripType.Walk,
    name: 'Walk',
    points_per_unit: 1,
    takes_number: true
  },
  {
    id: TripType.MP ,
    name: 'Pray Morning Prayer',
    short_name: 'Morning Prayer',
    points_per_unit: 1,
  },
  {
    id: TripType.NP ,
    name: 'Pray Noonday Prayer',
    short_name: 'Noonday Prayer',
    points_per_unit: 1,
  },
  {
    id: TripType.EP ,
    name: 'Pray Evening Prayer',
    short_name: 'Evening Prayer',
    points_per_unit: 1,
  },
  {
    id: TripType.Compline ,
    name: 'Pray Compline',
    short_name: 'Compline',
    points_per_unit: 1,
  },
  {
    id: TripType.PrayerList ,
    name: 'Pray for the people on your parish prayer list',
    short_name: 'Prayer List',
    points_per_unit: 0.5,
  },
  {
    id: TripType.Silence ,
    name: 'Sit in silence for 15 minutes',
    short_name: 'Silence',
    points_per_unit: 1,
  },
  {
    id: TripType.Icon ,
    name: 'Pray with an icon',
    points_per_unit: 1,
  },
  {
    id: TripType.Yoga ,
    name: 'Do 15+ minutes of yoga',
    points_per_unit: 1,
  },
  {
    id: TripType.InviteToChurch ,
    name: 'Invite someone to come to church',
    points_per_unit: 1.5,
  },
  {
    id: TripType.SundayWorship ,
    name: 'Attend a Sunday worship service',
    points_per_unit: 1,
  },
  {
    id: TripType.ReadAChapter ,
    name: 'Read a chapter from a Gospel or an Epistle',
    points_per_unit: 1,
  },
  {
    id: TripType.CallAFriend ,
    name: 'Call a friend and pray with them',
    points_per_unit: 1,
  },
  {
    id: TripType.WriteALetter ,
    name: 'Write a letter of gratitude to someone',
    points_per_unit: 1,
  },
  {
    id: TripType.MemorizeAVerse ,
    name: 'Memorize a new Bible verse',
    points_per_unit: 1,
  },
  {
    id: TripType.ListenToAPodcast ,
    name: 'Listen to an episode of an Episcopal podcast',
    points_per_unit: 0.5,
  },
  {
    id: TripType.ReadDevotional ,
    name: 'Read from a devotional',
    points_per_unit: 0.5,
  },
  {
    id: TripType.IncreasePledge,
    name: 'Increase your Pledge',
    points_per_unit: 2,
  },
  {
    id: TripType.BakeCookies,
    name: 'Bake your Priest some Cookies',
    points_per_unit: 2,
  },
  {
    id: TripType.GiveSomethingAway,
    name: 'Give away something you own and don’t use or need',
    points_per_unit: 2,
  },
  {
    id: TripType.Charity,
    name: 'Do an act of charity or outreach',
    points_per_unit: 1,
  },
]